import { WallboxConfigurationModel } from 'src/Libs/wallboxes'
import { Box, Typography } from '@mui/material'
import SettingsBox from 'src/Elements/Data/SettingsBox'
import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useWallboxSettingsFormHelpers } from 'src/Libs/wallboxes/hooks'
import SingleToggleSettingBox from '../../../../../Elements/SystemSettings/forms/setting-boxes/SingleToggleSettingBox'
import TextField from '../../../../inputs/formik/TextField'

interface Props {
  model: WallboxConfigurationModel
  disabled?: boolean
}

const NetworkFieldSet: React.FC<Props> = ({ model, disabled = false }) => {
  const { t } = useCustomTranslation()
  const { areNetworkSettingsChangeable } = useWallboxSettingsFormHelpers(model)
  const doDisable = !areNetworkSettingsChangeable || disabled

  return (
    <Box>
      <Typography variant="h2" sx={{ pt: 4, pb: 4 }}>
        {t('systemSettings.wallbox.settings.network.title')}
      </Typography>
      <SingleToggleSettingBox title={t('systemSettings.wallbox.settings.dhcpEnabled')} name="dhcpEnabled" disabled={true} />
      <SettingsBox
        disabled={doDisable}
        title={t('systemSettings.wallbox.settings.ipAddr')}
        suffix={<TextField name="ipAddress" disabled={doDisable} label={t('systemSettings.wallbox.settings.ipAddr')} />}
      />
      <SettingsBox
        disabled={doDisable}
        title={t('systemSettings.wallbox.settings.subnetMask')}
        suffix={<TextField name="subnetMask" disabled={doDisable} label={t('systemSettings.wallbox.settings.subnetMask')} />}
      />
      <SettingsBox
        disabled={doDisable}
        title={t('systemSettings.wallbox.settings.gateway')}
        suffix={<TextField name="gateway" disabled={doDisable} label={t('systemSettings.wallbox.settings.gateway')} />}
      />
    </Box>
  )
}

export default NetworkFieldSet
